export default __webpack_public_path__ + "static/media/rabbit_type_1_2.23070ce9.svg";